<template>
  <div class="content">

    <div class="table-responsive">
      <table class="table table-hover table-clean table-vcenter" style="width:100%;">
        <thead>
          <tr>
            <th width="15%" class="text-nowrap">{{ $t('number') }}</th>
            <th width="15%" class="text-nowrap">{{ $t('date') }}</th>
            <th width="*" class="text-nowrap">{{ $t('income') }}</th>
            <th width="*" class="text-nowrap">{{ $t('amount') }}</th>
            <th width="20%" class="text-nowrap">{{ $t('cachier') }}</th>
            <th width="30%">{{ $t('booking') }}</th>
            <th width="*" class="text-nowrap">{{ $t('verified') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invoice in pagination.invoices" @click="openPDF(invoice._id)">
            <td>{{ invoice.premise.label }}-{{ invoice.device.label }}-{{ invoice.index }}</td>
            <td>{{ invoice.issued.date | date }} {{ invoice.issued.time }}</td>
            <td>{{ invoice.services | incomeAmount }}€</td>
            <td>{{ invoice.services | totalAmount }}€</td>
            <td>{{ invoice.cachier.name.first }} {{ invoice.cachier.name.last }}</td>
            <td>
              {{ invoice.booking.room.name }}
              -
              {{ invoice.booking.night.first | date }} - {{ invoice.booking.night.last | checkOut }}
            </td>
            <td>
              <i v-if="invoice.eor" class="fa fa-check-circle text-success" aria-hidden="true"></i>
              <i v-else class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dataTables_wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="dt-basic_info" role="status" aria-live="polite">
            {{ $t('showing') }}
            {{ pagination.first }}
            <span v-if="pagination.invoices.length">
              {{ $t('to') }} {{ pagination.first + pagination.invoices.length - 1 }}
            </span>
            {{ $t('of') }}
            {{ pagination.total }}
            {{ $t('entries') }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <pagination v-bind:pages="pagination.pages"></pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '../../pagination/Pagination.vue';
import io from 'socket.io-client';

import moment from 'moment';

export default {
  name: 'InvoiceList',
  components:{
    Pagination
  },
  data: () => ({
    pagination: {
      invoices: [],
      pages: 1,
      total: 0,
      first: 0
    },
    property: {},
  }),
  filters: {
    date: function(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    checkOut: function(date){
      if(!date) return '';
      return moment(date).add(1, 'days').format('DD/MM/YYYY');
    },
    totalAmount: function(services){
      let amount = 0;
      services.forEach(s => {
        amount += s.price * s.quantity;
      });
      return amount.toFixed(2);
    },
    incomeAmount: function(services){
      let amount = 0;
      services.forEach(s => {
        amount += s.price * (100 / (100 + s.taxRate)) * s.quantity;
      });
      return amount.toFixed(2);
    }
  },
  created(){

    const propSlug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == propSlug);

    this.loadInvoices();
  },
  methods: {
    openPDF: function(_id){
      window.open('/' + this.$i18n.locale + '/' + this.$t('invoices') + '/' + _id, '_blank');
    },
    loadInvoices: function(){

      let url = '/invoices?property._id=' + this.property._id;

      const page = this.$route.query.page || 1;
      const roomSlug = this.$route.params.room;

      if(roomSlug){
        url += '&roomSlug=' + roomSlug;
      }

      const search= this.$route.query.search;
      if(search){
        url += '&search=' + search;
      }

      fetch(process.env.VUE_APP_API + url + '&limit=20&skip=' + ((page - 1) * 20), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log(result);
        if(!result.error){
          return this.pagination = result;
          console.log(this.pagination);
        }
      })
    }
  }
};
</script>

<i18n>
{
  "en": {
    "invoices": "invoices",
    "number": "Invoice number",
    "date": "Date issued",
    "income": "Income",
    "amount": "Amount",
    "cachier": "Cachier",
    "booking": "Booking",
    "verified": "Verified",
    "showing": "Showing",
    "to": "to",
    "of": "of",
    "entries": "entries"
  },
  "sl": {
    "invoices": "racuni",
    "number": "Številka računa",
    "date": "Datum izdaje",
    "income": "Prihodek",
    "amount": "Znesek",
    "cachier": "Blagajnik",
    "booking": "Rezervacija",
    "verified": "Potrjeno",
    "showing": "Prikazanih",
    "to": "do",
    "of": "od",
    "entries": "vnosov"
  }
}
</i18n>
